import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';

import { IExpiryScale } from 'graphql/types';
import { TControllerProps } from 'common/types';
import { asTypedControl } from 'common/utils/form';
import { SelectField } from 'common/forms/Field';

interface IProps {
    name: string;
    expiry?: number;
}

export const ExpiryScaleSelectField = <TFieldValues extends FieldValues>({
    name,
    control: formControl,
    expiry,
}: IProps & TControllerProps<TFieldValues>) => {
    const control = asTypedControl<IExpiryScale>(name, formControl);
    const [translate] = useTranslation();

    const expiryScaleOptions = useMemo(
        () => [
            {
                label: translate('certificateForm.expiryScaleOptions.days', {
                    count: Number(expiry) || 0,
                }),
                value: IExpiryScale.Days,
            },
            {
                label: translate('certificateForm.expiryScaleOptions.weeks', {
                    count: Number(expiry) || 0,
                }),
                value: IExpiryScale.Weeks,
            },
            {
                label: translate('certificateForm.expiryScaleOptions.months', {
                    count: Number(expiry) || 0,
                }),
                value: IExpiryScale.Months,
            },
            {
                label: translate('certificateForm.expiryScaleOptions.years', {
                    count: Number(expiry) || 0,
                }),
                value: IExpiryScale.Years,
            },
        ],
        [expiry]
    );

    return (
        <SelectField
            control={control}
            label={translate('certificateForm.expiryScale')}
            name={name}
            options={expiryScaleOptions}
        />
    );
};
